/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1255c2802046391a83412cb4bc8b9885>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "TextDensityCompress".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-density-compress
 * Usage guidance:
 * Reserved for increasing the density of text by reducing font size and/or line height.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const TextDensityCompressIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "TextDensityCompressIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M4.723 3a.75.75 0 0 1 .712.513L7.43 9.496l1.03 3.012a.8.8 0 0 1 .04.242V13H7v-.125l-.815-2.386H2.32l-.82 2.385V13H0v-.25l.01-.124a1 1 0 0 1 .031-.12l1.035-3.01 2.006-5.984.047-.11A.75.75 0 0 1 3.793 3zM13 3v5.44l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V3zM2.827 8.99H5.68L4.257 4.723z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
TextDensityCompressIcon.displayName = 'TextDensityCompressIcon';
var _default = exports.default = TextDensityCompressIcon;